import { InternalAxiosRequestConfig } from 'axios'

export const getFileHeaders = async (config: InternalAxiosRequestConfig) => {
  return {
    ...config,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      ...config.headers,
    },
  } as InternalAxiosRequestConfig
}
